import { render, staticRenderFns } from "./OnePageHeader.vue?vue&type=template&id=1bf554ce&"
import script from "./OnePageHeader.vue?vue&type=script&lang=js&"
export * from "./OnePageHeader.vue?vue&type=script&lang=js&"
import style0 from "./OnePageHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports